<template>
  <div class="category-container">
    <transition-group name="staggered-fade">
      <template v-if="show">
        <div v-for="(categori, index) in categories" :key="`${categori['category_name']}-${index}`"
          class="modern-card-wrapper">
          <div v-if="categori.category_id" class="category-header" @click="categori['opened'] = !categori['opened']">
            <div class="header-left">
              <ion-icon v-if="categori.has_order" :icon="bookmark" class="ordered-badge"></ion-icon>
              <span class="category-title">{{ categori["category_name"] }}</span>
            </div>
            <ion-icon :icon="categori['opened'] ? arrow2 : arrow" class="chevron-icon"></ion-icon>
          </div>

          <transition name="expand">
            <div v-show="categori['opened']" class="product-list">
              <div class="modern-product-card" v-for="(product, idx) in categori['products']"
                :key="`${product.product_id}-${idx}`">
                <div class="product-content">
                  <div class="img-container"
                    @click="detailsProduct(product['product_id'], product['product_detail_id'], product['name'], product['price_sell'], product['description'], product['photo'], product['stock_status'], product['tax'])">
                    <img
                      :src="product['photo'] || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'"
                      alt="Product" class="minimal-img" />
                    <div v-if="product['stock_status'] == 'unavailable'" class="sold-out-overlay">
                      <span>Habis</span>
                    </div>
                  </div>

                  <div class="product-info">
                    <h6 class="product-name">{{ product["name"] }}</h6>
                    <div class="product-desc" v-if="product['description']" v-html="product['description']"></div>

                    <div class="product-footer">
                      <span class="product-price" v-if="product['stock_status'] == 'available'">
                        {{ formatter.format(product["price_sell"]) }}
                      </span>
                      <span v-else class="status-out">Stok Habis</span>

                      <div class="action-area">
                        <transition name="scale" mode="out-in">
                          <button v-if="!result(product['product_detail_id'])" class="btn-add-minimal"
                            :disabled="product['stock_status'] == 'unavailable'"
                            @click="add(product['name'], product['price_sell'], product['product_id'], product['product_detail_id'], product['photo'], '', product['tax'])">
                            Tambah
                          </button>

                          <div v-else class="qty-control-modern">
                            <button class="qty-btn" @click="minus(product['name'])">−</button>
                            <span class="qty-val">{{ result(product["product_detail_id"]) }}</span>
                            <button class="qty-btn" @click="sum(product['name'])">+</button>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </transition>

          <!-- filterd results -->
          <div v-if="categori.product_id" class="modern-product-card search-result">
            <div class="modern-product-card">
              <div class="product-content">
                <div class="img-container"
                  @click="detailsProduct(categori['product_id'], categori['product_detail_id'], categori['name'], categori['price_sell'], categori['description'], categori['photo'], categori['stock_status'], categori['tax'])">
                  <img
                    :src="categori['photo'] || 'https://res.cloudinary.com/dxcleuxwe/image/upload/v1758687442/placeholder/no-product-image_v7tdrr.png'"
                    alt="Product" class="minimal-img" />
                  <div v-if="categori['stock_status'] == 'unavailable'" class="sold-out-overlay">
                    <span>Habis</span>
                  </div>
                </div>

                <div class="product-info">
                  <h6 class="product-name">{{ categori["name"] }}</h6>
                  <div class="product-desc" v-if="categori['description']" v-html="categori['description']"></div>

                  <div class="product-footer">
                    <span class="product-price" v-if="categori['stock_status'] == 'available'">
                      {{ formatter.format(categori["price_sell"]) }}
                    </span>
                    <span v-else class="status-out">Stok Habis</span>

                    <div class="action-area">
                      <transition name="scale" mode="out-in">
                        <button v-if="!result(categori['product_detail_id'])" class="btn-add-minimal"
                          :disabled="categori['stock_status'] == 'unavailable'"
                          @click="add(categori['name'], categori['price_sell'], categori['product_id'], categori['product_detail_id'], categori['photo'], '', categori['tax'])">
                          Tambah
                        </button>

                        <div v-else class="qty-control-modern">
                          <button class="qty-btn" @click="minus(categori['name'])">−</button>
                          <span class="qty-val">{{ result(categori["product_detail_id"]) }}</span>
                          <button class="qty-btn" @click="sum(categori['name'])">+</button>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </transition-group>
  </div>
</template>

<script>
import { IonIcon } from '@ionic/vue';
import { bookmark, caretForwardOutline, caretDownOutline } from 'ionicons/icons';
import { storage } from '../utils/storage';


export default {
  name: "PandaCategory",
  props: ["categories", "productFormLocalStorage", "show", "linkMenus"],
  components: { IonIcon },
  data() {
    return {
      bookmark,
      formatter: new Intl.NumberFormat("ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 2,
      }),
      arrow: caretForwardOutline,
      arrow2: caretDownOutline,
      outletProducts: [],
      lastOrder: [],
      product: [],
    };
  },
  mounted() {
    this.product = this.productFormLocalStorage;
    // setTimeout(() => {
    //   this.categories.forEach((v) => {
    //     v.products.forEach((w) => {
    //       this.product.forEach((x) => {
    //         if (w.product_id == x.product_id) {
    //           v.has_order = true;
    //         }
    //       });
    //     });
    //   });
    // }, 1000);
  },
  updated() {
    // this.categories.forEach((v) => {
    //   v.products.forEach((w) => {
    //     this.product.filter((e) => {
    //       if (e.product_id == w.product_id) {
    //         v.has_order = true;
    //       }
    //     });
    //     // this.product.forEach((x) => {
    //     //   if (w.product_id == x.product_id) {
    //     //     v.has_order = true;
    //     //   }
    //     // });
    //   });
    // });
  },
  methods: {
    resolveProduct(detailId) {
      if (!this.categories) return null;
      for (const cat of this.categories) {
        if (!cat.products) continue;
        const prod = cat.products.find(p => p.product_detail_id == detailId);
        if (prod) return prod;
      }
      return null;
    },
    resultItem(detail_id) {
      this.result(detail_id)
    },
    addFromTopPick(product) {
      const normalized = this.categories.flatMap((item) =>
        Array.isArray(item.products) ? item.products : item
      );

      const filtered = normalized.find(
        (it) => it.product_id === product.product_id
      );

      this.add(
        product.name,
        product.price_sell,
        product.product_id,
        product.product_detail_id,
        product.photo,
        "",
        filtered?.tax || []
      )
    },
    //* Add product to cart
    add(name, price, productId, detailid, photo, note = "", tax) {
      // Check if product has linked menu with valid items
      const hasLinkMenu = this.linkMenus && this.linkMenus.some(
        (m) => m.product_detail_fkid === detailid &&
               m.link_menu_detail &&
               m.link_menu_detail.some(detail => !!this.resolveProduct(detail.product_detail_fkid))
      );

      if (hasLinkMenu) {
        this.$emit("open-link-menu", {
          name,
          price,
          product_id: productId,
          product_detail_id: detailid,
          photo,
          note,
          tax,
        });
        return;
      }

      let permanenttax = [];
      if (tax) {
        for (let i = 0; i < tax.length; i++) {
          if (tax[i]["tax_status"] == "permanent") {
            permanenttax.push(tax[i]);
          }
        }
      }
      
      this.product.push({
        product_name: name,
        price: price,
        product_id: productId,
        product_detail_id: detailid,
        qty: 1,
        photo,
        note,
        tax: permanenttax,
      });
      this.$emit("get-items", this.product);
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: this.product }))
    },
    //* Add qty product
    sum(name) {
      for (let i = 0; i < this.product.length; i++) {
        if (this.product[i].product_name == name) {
          this.product[i].qty += 1;
        }
      }
      this.$emit("get-items", this.product);
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: this.product }))
    },
    //* Returning products qty value
    result(detail_id) {
      if (this.product.length) {
        // console.log(this.product);
        for (let i = 0; i < this.product.length; i++) {
          if (this.product[i].product_detail_id == detail_id) {
            return this.product[i].qty;
          }
        }
      }
    },
    //* substract qty products
    minus(name) {
      for (let i = 0; i < this.product.length; i++) {
        if (this.product[i].product_name == name) {
          if (this.product[i].qty) {
            this.product[i].qty -= 1;
            if (this.product[i].qty == 0) {
              this.product.splice(i, 1);
            }
          }
        }
      }
      this.$emit("get-items", this.product);
      const outlet_id = this.$route.params.id;
      storage.setLastOrder(JSON.stringify({ outlet_id, products: this.product }))
    },
    showAllProducts() {
      for (let i = 0; i < this.categories.length; i++) {
        if (this.categories[i].products.length) {
          for (let b = 0; b < this.categories[i].products.length; b++) {
            this.outletProducts = this.categories[i].products[b];
          }
        }
      }
    },
    detailsProduct(
      id,
      detailId,
      name,
      price,
      description,
      image = "",
      status,
      tax
    ) {
      let product = {
        id,
        detailId,
        name,
        price,
        description,
        image,
        status,
        tax,
      };
      this.$emit("details-product", product);
    },
    hasOrder(categori) {
      if (categori.has_order == false) {
        categori.has_order = true;
      }
    },
  },
};
</script>

<style scoped>
.category-container {
  padding: 8px 0;
  background: #f8f9fa;
}

/* Category Header */
.category-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 16px;
  cursor: pointer;
  margin-bottom: 10px;
  border-radius: 14px;
  background-color: white;
}

.modern-card-wrapper {
  background-color: white;
  border-radius: 14px;
}

.category-title {
  font-weight: 700;
  font-size: 1.1rem;
  color: #2d3436;
  letter-spacing: -0.3px;
}

.chevron-icon {
  font-size: 1.2rem;
  color: #636e72;
}

/* Product Card */
.modern-product-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.03);
  transition: transform 0.2s active;
}

.modern-product-card:active {
  transform: scale(0.98);
}

.product-content {
  display: flex;
  gap: 12px;
}

/* Image */
.img-container {
  position: relative;
  width: 90px;
  height: 90px;
  flex-shrink: 0;
}

.minimal-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  background: #f1f2f6;
}

.sold-out-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: bold;
  color: #d63031;
  text-transform: uppercase;
}

/* Info Section */
.product-info {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.product-name {
  margin: 0 0 4px 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3436;
}

.product-desc {
  margin: 0;
  font-size: 0.8rem;
  color: #636e72;
  display: -webkit-box;
  /* -webkit-line-clamp: 2; */
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.product-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}

.product-price {
  font-weight: 700;
  font-size: 0.95rem;
  color: #e84118;
}

.status-out {
  font-size: 0.8rem;
  color: #b2bec3;
  font-style: italic;
}

/* Action Buttons */
.btn-add-minimal {
  background: #ffffff;
  border: 1.5px solid #e84118;
  color: #e84118;
  padding: 4px 16px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-add-minimal:disabled {
  border-color: #dfe6e9;
  color: #b2bec3;
}

/* Qty Controls */
.qty-control-modern {
  display: flex;
  align-items: center;
  background: #f1f2f6;
  border-radius: 20px;
  padding: 2px;
}

.qty-btn {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  background: #ffffff;
  color: #e84118;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.qty-val {
  padding: 0 10px;
  font-weight: 700;
  font-size: 0.9rem;
  min-width: 30px;
  text-align: center;
}

/* Animations */
.scale-enter-active,
.scale-leave-active {
  transition: all 0.2s ease;
}

.scale-enter-from,
.scale-leave-to {
  transform: scale(0.8);
  opacity: 0;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.3s ease-in-out;
  overflow: hidden;
}

.expand-enter-from,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to,
.expand-leave-from {
  max-height: 1000px;
  opacity: 1;
}

.ordered-badge {
  color: #fab1a0;
  margin-right: 8px;
  font-size: 1.2rem;
}

.header-left {
  display: flex;
  align-items: center;
}
</style>